import React from 'react';

const LoadingSkeleton = ({ count = 12 }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-4">
      {Array.from({ length: count })?.map((_, index) => (
        <div key={index} className="bg-card rounded-lg shadow-subtle overflow-hidden animate-pulse">
          {/* Cover Image Skeleton */}
          <div className="aspect-[3/4] bg-muted" />
          
          {/* Content Skeleton */}
          <div className="p-3 space-y-2">
            {/* Title */}
            <div className="h-4 bg-muted rounded w-full" />
            <div className="h-4 bg-muted rounded w-3/4" />
            
            {/* Author */}
            <div className="h-3 bg-muted rounded w-1/2" />
            
            {/* Price */}
            <div className="h-4 bg-muted rounded w-1/3" />
            
            {/* Category */}
            <div className="h-6 bg-muted rounded-full w-2/3" />
            
            {/* Button */}
            <div className="h-8 bg-muted rounded w-full" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
